import { isProduction, isStaging } from '@utils/environment';

export const getRailsHost = () => {
  if (isProduction()) return 'https://admin.hellotech.com';
  if (isStaging()) return 'https://admins.hellotech.com';
  return 'http://localhost';
};
